import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/services/")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Business Consulting Services",
      description:
        "SBA loan consulting, business plan writing, grants, startup launch, operations, and AI strategy.",
      path: "/services",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"Services"} intro={"[SUPPLY: services overview copy]"} />;
}
